import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { StyleContext } from "../providers/StyleContextProvider";
import { useMediaQuery } from "react-responsive";
import { Header } from "../components/shared/Header";
import { Button } from "../components/shared/Button";
import { ErrorTexts as Texts } from "../helpers/LayoutTexts";

const ErrorPage: React.FC = () => {
    const navigate = useNavigate();
    const styleContext = useContext(StyleContext);
    const [styles, setStyles] = useState<any>(styleContext.getComponentStyle("errorPage"));                
    const isMobile = useMediaQuery({ query: "(max-width: 786px)" });
        
    useEffect(() => {        
        setStyles(styleContext.getComponentStyle("errorPage"));
    }, [isMobile]);
    
    const backToHome = () => {
        navigate('/');
    }

    return (
        <>
            <Header />
            <div style={styles.container}>                
                <div style={styles.oopsText}>{"Oops!"}</div>
                <div style={styles.connectText}>{Texts.connect}</div>
                <div style={styles.unavailableText}>{Texts.unavailable}</div>
                <Button style={styles.backButton} onClick={backToHome}>{"BACK TO HOME"}</Button>                
                <div style={styles.copyright}>{Texts.copyright}</div>                
            </div>
        </>
    );
}

export default ErrorPage;